












import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  ref
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '@storefront-ui/vue';
import throttle from 'lodash.throttle';

import { useLink } from '~/diptyqueTheme/composable/useLink';
import type { Breadcrumb } from '~/modules/GraphQL/types';


export default defineComponent({
  name: 'VaimoBreadcrumbs',
  components: {
    SfBreadcrumbs
  },
  props: {
    breadcrumbs: {
      type: Array as PropType<Array<Breadcrumb>>,
      default: () => []
    }
  },
  setup(props) {
    const { normalizeLink } = useLink();
    const breadcrumbsWrapper = ref(null);
    const scrollPosition = ref(0);
    const contentScrollWidth = ref(0);
    const RIGHT_FADE_THRESHOLD = 0.95;
    const SCROLL_THROTTLE_DELAY = 100;

    const preprocessedBreadcrumbs = computed(() =>
      props.breadcrumbs.map((b) => {
        b.link = normalizeLink(b.link) || '';
        if (b.title && !b.text) {
          b.text = b.title;
        }
        return b;
      })
    );

    const showLeftFade = computed(() => scrollPosition.value > 0);
    const showRightFade = computed(
      () =>
        scrollPosition.value < RIGHT_FADE_THRESHOLD &&
        breadcrumbsWrapper.value?.scrollWidth !==
          breadcrumbsWrapper.value?.offsetWidth
    );

    const wrapperClasses = computed(() => {
      return {
        'breadcrumbs-fade-left': showLeftFade.value,
        'breadcrumbs-fade-right': showRightFade.value
      };
    });

    const checkScroll = () => {
      const wrapper = breadcrumbsWrapper.value;
      contentScrollWidth.value = wrapper.scrollWidth - wrapper.offsetWidth;
      scrollPosition.value = wrapper.scrollLeft / contentScrollWidth.value;
    };

    onMounted(() => {
      breadcrumbsWrapper.value.addEventListener(
        'scroll',
        throttle(checkScroll, SCROLL_THROTTLE_DELAY)
      );
    });

    onUnmounted(() => {
      breadcrumbsWrapper.value.removeEventListener('scroll', checkScroll);
    });

    return {
      preprocessedBreadcrumbs,
      breadcrumbsWrapper,
      wrapperClasses
    };
  }
});
